/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getManufacturerCodeAsync } from './DataActionExtension.g';
import { IManufacturerCodeResponseEntity } from './DataServiceEntities.g';

/**
 * GetManufacturerCodes Input Action
 */
export class GetManufacturerCodesInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `ManufacturerCodes`;
    public getCacheObjectType = () => 'ManufacturerCodes';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetManufacturerCodesData {
    manufacturerCodes: IManufacturerCodeResponseEntity[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createManufacturerCodeInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetManufacturerCodesInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetManufacturerCodesInput, ctx: Msdyn365.IActionContext): Promise<IGetManufacturerCodesData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    const response = await getManufacturerCodeAsync({ callerContext: ctx });
    const codes = response;
    return { manufacturerCodes: codes };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetManufacturerCodesData>>action,
    // TODO: Give your data action a unique id
    id: 'GetManufacturerCodes',
    input: createManufacturerCodeInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
